import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { FailIcon } from 'assets/icons';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

const ModalClearAll = ({
  buttonStyle,
  loading,
  clearFunction,
  type
}) => {

  const [isOpen, setIsOpen] = useState(false)
  const handleClearAll = () => {
    if(loading) return
    clearFunction()
      .then((response) => {
        const content = `${type}s have been successfully cleared`
        message.success(content)
        setIsOpen(false)
      })
      .catch((error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
        debouncedErrorMessage(content);
        }
      })
  }

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-danger"
      buttonLabel="Clear All"
      buttonStyle={buttonStyle}
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <FailIcon />
        <div className="text">
          {`Are you sure you want to clear all ${type}s? This action cannot be undone.`}
        </div>
        <div className="buttonContainer">
          <Button
            danger
            onClick={() => setIsOpen(false)}
            additionalstyle={`
              width: 79px;
              margin-right: 16px;
            `}
          >
            Cancel
          </Button>
          <Button
            success
            onClick={handleClearAll}
            data-loading={loading}
            additionalstyle={`
              width: 72px;
            `}
          >
            {loading ? null : "Clear All"}
          </Button>
        </div>
      </Container>
    </MainModal>
  );
}

export default ModalClearAll;
